const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      slider: '.js-carousel-slider',
      wrapper: '.js-carousel-slider-wrapper',
      item: '.js-carousel-slider-item',
      prev: '.js-slider-btn-prev',
      next: '.js-slider-btn-next',
      image: '.js-carousel-image',
      dotsContainer: '.js-slider-pagination',
      navContainer: '.js-slider-navigation',
      ytPlayer: '.js-carousel-slider-yt-player',
    };

    this.classes = {
      noSlider: 'has-no-slider',
      isInit: 'slick-initialized',
      hidden: 'u-hidden',
      dots: 'b-slider__dots',
    };
    this.count = 0;
    this.mq = window.matchMedia('(min-width: 1024px)');
    this.$sliders = $(this.selectors.slider);

    if (!this.$sliders.length) {
      return;
    }

    this.YT = null;
    this.ytPlayers = [];

    $(document).ready(() => {
      this.init();
      this.initYTPlayerScript();
    });
  }

  init() {
    window.addEventListener('carouselSliderReady', () => {
      this.initSlider();
    });
  }

  initYTPlayerScript() {
    const players = document.querySelectorAll(this.selectors.ytPlayer);
    const event = new CustomEvent('carouselSliderReady');

    if (players.length) {
      const tag = document.createElement('script');

      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      tag.onload = () => {
        this.YT = window.YT;

        this.YT.ready(() => {
          window.dispatchEvent(event);
        });
      };
    } else {
      window.dispatchEvent(event);
    }
  }

  createYTPLayer = slider => {
    const slides = slider.find(this.selectors.item);

    if (slides.length) {
      slides.each((index, item) => {
        const $item = $(item);
        const ytPlayer = $item.find(this.selectors.ytPlayer);
        const videoId = ytPlayer.attr('data-video-id');

        const player = new this.YT.Player(ytPlayer[0], {
          videoId,
          height: '315',
          width: '560',
          playerVars: {
            autoplay: false,
            color: 'red',
            modestbranding: true,
            rel: 0,
          },
        });

        this.ytPlayers.push(player);
      });
    }
  };

  initSlider() {
    this.$sliders.each((index, item) => {
      const $slider = $(item);
      const $wrapper = $slider.closest(this.selectors.wrapper);
      const count = $slider.find(this.selectors.item).length;
      const dotsContainer = $slider.parent().find(this.selectors.dotsContainer);
      const navContainer = $slider.parent().find(this.selectors.navContainer);
      const sliderName = $slider.attr('data-name');
      let countMax = 4;

      const options = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        dots: true,
        dotsClass: this.classes.dots,
        appendDots: dotsContainer,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
            },
          },
        ],
      };

      switch (sliderName) {
        case 'gallery':
          delete options.responsive;
          break;
        case 'engines':
          countMax = 3;
          options.responsive[1].settings.slidesToShow = countMax;
          break;
        case 'videos':
          this.createYTPLayer($slider);
          delete options.responsive;
          break;
        case 'logos':
          countMax = 4;
          options.slidesToShow = 2;
          options.responsive = [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: count > 4 ? 5 : 4,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: count > 5 ? 6 : 5,
              },
            },
          ];
          break;
        case 'vision':
          delete options.responsive;
          break;
        default:
          break;
      }

      options.prevArrow = $wrapper.find(this.selectors.prev);
      options.nextArrow = $wrapper.find(this.selectors.next);

      if (
        count > 0 &&
        count <= countMax &&
        this.mq.matches &&
        options?.responsive &&
        sliderName !== 'logos'
      ) {
        options.responsive[1].settings.slidesToShow = count;
      }

      if ($slider.hasClass(this.classes.isInit)) {
        $slider.slick('unslick');
      }

      $slider.on('init', () => {
        $wrapper.removeClass(this.classes.noSlider);
      });

      $slider.on('breakpoint', () => {
        $slider.slick('unslick');
        this.initSlick($slider, options);
      });

      let debounce;
      $slider.on('setPosition', (e, slick) => {
        clearTimeout(debounce);

        debounce = setTimeout(() => {
          if (sliderName === 'related') {
            let paddingLeft = 0;
            if (count < 4 && this.mq.matches) {
              const itemWidth = $slider.find(this.selectors.item).outerWidth();
              paddingLeft = (itemWidth * (4 - count)) / 2;
            }
            slick.$slideTrack.css('padding-left', 0);
            slick.$slideTrack.css('padding-left', `${paddingLeft}px`);
          }

          const hasDots = dotsContainer.children().length;
          navContainer.toggleClass(this.classes.hidden, !hasDots);
        }, 500);
      });

      $slider.on('beforeChange', (slick, currentSlide) => {
        if (sliderName === 'videos') {
          const activePlayer = this.ytPlayers[currentSlide.currentSlide];

          if (activePlayer?.videoTitle) {
            activePlayer.pauseVideo();
          }
        }
      });

      this.initSlick($slider, options);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  initSlick($slider, options) {
    $slider.slick(options);
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/carousel-slider.js